import React, { useState, useEffect } from "react";
import { useNavigate,useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import logoBlack from "../../assets/logo/maturytics_logo_black.svg";
import logoWhite from "../../assets/logo/maturytics_logo_white.svg";
import { setThemeMode, setLeftMenuVisibility, addTab, removeTab, setActiveTab, updateTabStates } from "../../store/actions";

const TopMenu = React.memo(() => {
  
  const themeMode = useSelector((state) => state.themeMode);
  // const leftMenuVisibility = useSelector((state) => state.leftMenuVisibility);
  const topMenuTabs = useSelector((state) => state.topMenuTabs);

  // const themeMode = topMenuTabs.tabs.find((tab) => tab.id === topMenuTabs.activeTab).states.themeMode;
  const leftMenuVisibility = topMenuTabs.tabs.find((tab) => tab.id === topMenuTabs.activeTab).states.leftMenuVisibility;

  const [smallScreen, setSmallScreen] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [open,setOpen]=useState(false)
  const [time, setTime] = useState("");
  const location = useLocation();
  const updateClock = () => {
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");
    setTime(`${hours}:${minutes}:${seconds}`);
  };

  const addNewTab = () => {
    dispatch(addTab(topMenuTabs.tabs.reduce((max, tab) => (tab.id > max.id ? tab : max), topMenuTabs.tabs[0])["id"] + 1));
    navigate("/");
  };

  const closeTab = (id) => {
    setTimeout(() => {
      dispatch(removeTab(id));
    }, 1);
  };

  useEffect(() => {
    updateClock();
    const interval = setInterval(updateClock, 1000);
    return () => clearInterval(interval); // Temizleme
  }, []);

  const changeThemeMode = () => {
    const newThemeMode = themeMode === "dark" ? "light" : "dark";
    dispatch(setThemeMode(newThemeMode));
    // dispatch(updateTabStates(topMenuTabs.activeTab, 'themeMode', themeMode === "dark" ? "light" : "dark"));
    localStorage.setItem('themeMode', newThemeMode);
  };
  const changeVisibilty = () => {
    console.log(leftMenuVisibility);
    // dispatch(
    //   setLeftMenuVisibility(leftMenuVisibility === "show" ? "hide" : "show")
    // );
    dispatch(updateTabStates(topMenuTabs.activeTab, 'leftMenuVisibility', leftMenuVisibility === "show" ? "hide" : "show"));
  };
  useEffect(() => {
    const handleResize = () => {
      // dispatch(
      //   setLeftMenuVisibility(window.innerWidth <= 640 ? "hide" : "show")
      // );
      dispatch(updateTabStates(topMenuTabs.activeTab, 'leftMenuVisibility', window.innerWidth <= 640 ? "hide" : "show"));
      console.log(window.innerWidth);
      setSmallScreen(window.innerWidth <= 640 ? true : false);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div
      className={`w-full h-[36px] border-b flex z-50 flex justify-between items-center flex-100  w-full px-[1.125rem] ${
        themeMode === "dark"
          ? "bg-[#1a1928] border-white/5"
          : "bg-[#ffffff] border-zinc-950/5"
      }`}
    >
      <div
        className={`text-2xl font-semibold w-[75%] ${
          themeMode === "dark" ? "text-white" : "text-gray-600"
        }`}
      >
        <div className="flex flex-col col-6">
          <div className="flex gap-1  cursor-context-menu items-center">
            <div className="block sm:hidden" onClick={changeVisibilty}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                className="size-5"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
                />
              </svg>
            </div>
            <div className="flex align-items-center gap-2">
              <img
                alt="logo"
                src={themeMode === "dark" ? logoWhite : logoBlack}
                height="36px"
                className="mr-2 size-24 max-h-[36px] flex-shrink-0"
                style={{ cursor: "pointer" }}
                onClick={(e) => navigate("/home")}
              ></img>
            </div>
            {(smallScreen && topMenuTabs.tabs.length>1) ? (
              <div className="relative">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="size-6"
                  onClick={()=>setOpen(!open)}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M6.75 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM12.75 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM18.75 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"
                  />
                </svg>
                {open &&(
                <div className="z-[10000] fixed top-[46px] left-[117.031px] opacity-100 flex flex-col min-w-0 min-h-0 max-h-[calc(100vh-32px)] bg-transparent transform-origin-center">
                  <div className={`${themeMode==="dark"?"bg-[#2a2939] border-white-09":"bg-white border border-black-09"} rounded-lg shadow-black-2-shadow p-2.5 overflow-hidden flex flex-col w-fit min-w-[12.5rem] max-w-[17rem] max-h-[22rem]`}>
                    <div className="flex-grow min-h-0 h-max overflow-x-hidden overflow-y-auto">
                      <div className="flex flex-col h-full gap-1">
                        {topMenuTabs.tabs.map((tab) => (
                          <div
                            key={tab.id}
                            id={tab.id}
                            className="w-full overflow-x-auto flex items-center"
                          >
                            <span
                              className={`${
                                topMenuTabs.tabs.length > 1 ? "pr-1" : "pr-3"
                              } pl-[0.5rem] gap-2 flex items-center text-center justify-between text-[0.75rem] border rounded-[4px] truncate inline-block w-full h-[1.625rem] ${
                                themeMode === "dark"
                                  ? topMenuTabs.activeTab == tab.id
                                    ? "bg-[#252b3a] border-[#44506b] text-[#ffffffcc]"
                                    : "bg-[#ffffff14] border-[#ffffff14] text-[#ffffffcc] cursor-pointer hover:bg-[#ffffff0a]"
                                  : topMenuTabs.activeTab == tab.id
                                  ? "bg-[#f0f4ff] border-[#e6eaff] text-black"
                                  : "bg-[#00000014] border-[#00000014] text-[#000000cc] cursor-pointer hover:bg-[#0000000a]"
                              }`}
                              onClick={() => {
                                dispatch(setActiveTab(tab.id));
                                navigate(tab.path);
                              }}
                              title={tab.label}
                            >
                              <div
                                className={`icon flex justify-center items-center gap-2 ${
                                  themeMode === "dark"
                                    ? "bg-[1a1928] border-[#e0e0e0] text-gray"
                                    : "bg-[1a1928] border-[#e0e0e0] text-gray"
                                }`}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  strokeLinecap="1.5"
                                  stroke={`${
                                    themeMode === "dark"
                                      ? "#ffffffcc"
                                      : "#000000cc"
                                  }`}
                                  className="size-3"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M12 20.25c4.97 0 9-3.694 9-8.25s-4.03-8.25-9-8.25S3 7.444 3 12c0 2.104.859 4.023 2.273 5.48.432.447.74 1.04.586 1.641a4.483 4.483 0 0 1-.923 1.785A5.969 5.969 0 0 0 6 21c1.282 0 2.47-.402 3.445-1.087.81.22 1.668.337 2.555.337Z"
                                  />
                                </svg>
                                {tab.label}
                              </div>
                             
                              {topMenuTabs.tabs.length > 1 && (
                                <button
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    closeTab(tab.id);
                                  }}
                                  className="bg-gray text-black flex justify-center items-center border-none rounded-full text-sm font-medium text-current"
                                >
                                  <div
                                    className={`icon flex justify-center items-center rounded-[3px] ${
                                      themeMode === "dark"
                                        ? "bg-[#d1d5de0d] hover:bg-[#a5bdff1a] border-[#e0e0e0]"
                                        : "bg-[#1725470d] hover:bg-[#1725471a] border-[#1725471a]"
                                    }`}
                                  >
                                    <svg
                                      className="w-4 h-4"
                                      fill="currentColor"
                                      viewBox="0 0 16 16"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path d="M3.14645 3.14645C2.95118 3.34171 2.95118 3.65829 3.14645 3.85355L7.29289 8L3.14645 12.1464C2.95118 12.3417 2.95118 12.6583 3.14645 12.8536C3.34171 13.0488 3.65829 13.0488 3.85355 12.8536L8 8.70711L12.1464 12.8536C12.3417 13.0488 12.6583 13.0488 12.8536 12.8536C13.0488 12.6583 13.0488 12.3417 12.8536 12.1464L8.70711 8L12.8536 3.85355C13.0488 3.65829 13.0488 3.34171 12.8536 3.14645C12.6583 2.95118 12.3417 2.95118 12.1464 3.14645L8 7.29289L3.85355 3.14645C3.65829 2.95118 3.34171 2.95118 3.14645 3.14645Z"></path>
                                    </svg>
                                  </div>
                                </button>
                              )}
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
                )}
              </div>
            ) : (
              topMenuTabs.tabs.map((tab) => (
                <div
                  key={tab.id}
                  id={tab.id}
                  className="max-w-[50%] overflow-x-auto flex items-center"
                >
                  <span
                    className={`${
                      topMenuTabs.tabs.length > 1 ? "pr-1" : "pr-3"
                    } pl-[0.5rem] gap-2 flex items-center text-center text-[0.75rem] border rounded-[4px] truncate inline-block w-full h-[1.625rem] ${
                      themeMode === "dark"
                        ? topMenuTabs.activeTab == tab.id
                          ? "bg-[#252b3a] border-[#44506b] text-[#ffffffcc]"
                          : "bg-[#ffffff14] border-[#ffffff14] text-[#ffffffcc] cursor-pointer hover:bg-[#ffffff0a]"
                        : topMenuTabs.activeTab == tab.id
                        ? "bg-[#f0f4ff] border-[#e6eaff] text-black"
                        : "bg-[#00000014] border-[#00000014] text-[#000000cc] cursor-pointer hover:bg-[#0000000a]"
                    }`}
                    onClick={() => {
                      dispatch(setActiveTab(tab.id));
                      navigate(tab.path);
                    }}
                    title={tab.label}
                  >
                    <div
                      className={`icon flex justify-center items-center ${
                        themeMode === "dark"
                          ? "bg-[1a1928] border-[#e0e0e0] text-gray"
                          : "bg-[1a1928] border-[#e0e0e0] text-gray"
                      }`}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeLinecap="1.5"
                        stroke={`${
                          themeMode === "dark" ? "#ffffffcc" : "#000000cc"
                        }`}
                        className="size-3"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M12 20.25c4.97 0 9-3.694 9-8.25s-4.03-8.25-9-8.25S3 7.444 3 12c0 2.104.859 4.023 2.273 5.48.432.447.74 1.04.586 1.641a4.483 4.483 0 0 1-.923 1.785A5.969 5.969 0 0 0 6 21c1.282 0 2.47-.402 3.445-1.087.81.22 1.668.337 2.555.337Z"
                        />
                      </svg>
                    </div>
                    {tab.label}
                    {topMenuTabs.tabs.length > 1 && (
                      <button
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          closeTab(tab.id);
                        }}
                        className="bg-gray text-black flex justify-center items-center border-none rounded-full text-sm font-medium text-current"
                      >
                        <div
                          className={`icon flex justify-center items-center rounded-[3px] ${
                            themeMode === "dark"
                              ? "bg-[#d1d5de0d] hover:bg-[#a5bdff1a] border-[#e0e0e0]"
                              : "bg-[#1725470d] hover:bg-[#1725471a] border-[#1725471a]"
                          }`}
                        >
                          <svg
                            className="w-4 h-4"
                            fill="currentColor"
                            viewBox="0 0 16 16"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M3.14645 3.14645C2.95118 3.34171 2.95118 3.65829 3.14645 3.85355L7.29289 8L3.14645 12.1464C2.95118 12.3417 2.95118 12.6583 3.14645 12.8536C3.34171 13.0488 3.65829 13.0488 3.85355 12.8536L8 8.70711L12.1464 12.8536C12.3417 13.0488 12.6583 13.0488 12.8536 12.8536C13.0488 12.6583 13.0488 12.3417 12.8536 12.1464L8.70711 8L12.8536 3.85355C13.0488 3.65829 13.0488 3.34171 12.8536 3.14645C12.6583 2.95118 12.3417 2.95118 12.1464 3.14645L8 7.29289L3.85355 3.14645C3.65829 2.95118 3.34171 2.95118 3.14645 3.14645Z"></path>
                          </svg>
                        </div>
                      </button>
                    )}
                  </span>
                </div>
              ))
            )}
            <div className="ml-0 mr-4 items-center flex">
              <button
                className="h-[26px] w-[26px] flex justify-center items-center bg-transparent border-none rounded-full"
                onClick={addNewTab}
              >
                <div
                  className={`icon flex justify-center items-center hover:rounded-[3px] py-[1px] px-[1px] font-semibold ${
                    themeMode === "dark"
                      ? "hover:bg-[#d1d5de1a]"
                      : "hover:bg-[#1725471a]"
                  }`}
                >
                  <svg
                    className="w-4 h-4 text-current"
                    fill={`${themeMode === "dark" ? "currentColor" : "black"}`}
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 16 16"
                  >
                    <path d="M7.49988 8.49991V12.9999H8.49988V8.49991L13 8.49994L13 7.49994L8.49988 7.49991V2.99988H7.49988V7.49991L3.00001 7.49988L3 8.49988L7.49988 8.49991Z"></path>
                  </svg>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Sağdaki Menü */}
      <div className="flex items-center space-x-2 max-[470px]:justify-between text-[13px] ">
        {/* Arama Çubuğu */}
        {/* <div className="relative">
                        <form className="max-w-md mx-auto">
                            <label
                                htmlFor="default-search"
                                className="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white"
                            >
                                Search
                            </label>
                            <div className="relative">
                                <div className={`flex items-center cursor-pointer hover:bg-[#ffffff0a] hover:rounded-[4px] py-[1px] px-[1px] font-semibold ${themeMode === 'dark' ? "text-white hover:bg-[#ffffff0a]" : "text-black hover:bg-[#0000000a]"
                                    }`}>
                                    {themeMode === 'dark' ? (
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            strokeLinecap="1"
                                            stroke="#ffffffcc"
                                            className="size-[18px] hover:stroke-white"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
                                        </svg>
                                    ) : (
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            strokeLinecap="1"
                                            stroke="#00000099"
                                            className="size-5"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
                                        </svg>
                                    )}
                                </div>
                            </div>
                        </form>
                    </div> */}

        {/* Tema Değiştirme İkonu ve Menüsü */}
        <div className="relative">
          <button
            onClick={changeThemeMode}
            className={`flex items-center text-2xl hover:rounded-[4px] py-[2px] px-[4px] font-semibold ${
              themeMode === "dark"
                ? "text-white hover:bg-[#ffffff0a]"
                : "text-black hover:bg-[#0000000a]"
            }`}
          >
            {/* Dark Mode için Ay İkonu, Light Mode için Güneş İkonu */}
            {themeMode === "dark" ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeLinecap="1.5"
                stroke="#ffffffcc"
                className="size-4 hover:stroke-white"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M21.752 15.002A9.72 9.72 0 0 1 18 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 0 0 3 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 0 0 9.002-5.998Z"
                />
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeLinecap="1.5"
                stroke="#00000099"
                className="size-4"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M12 3v2.25m6.364.386-1.591 1.591M21 12h-2.25m-.386 6.364-1.591-1.591M12 18.75V21m-4.773-4.227-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z"
                />
              </svg>
            )}
          </button>
        </div>

        {/* Bulunulan Ülke */}
        <div
          className={`flex items-center max-[400px]:hidden  h-[20px] cursor-pointer hover:rounded-[4px] py-[1px] px-[8px] 
                            ${
                              themeMode === "dark"
                                ? "text-[#ffffffcc] hover:text-white hover:bg-[#ffffff0a]"
                                : "text-[#000000cc] hover:text-black hover:bg-[#0000000a]"
                            }`}
        >
          <div className="max-[400px]:hidden">{Intl.DateTimeFormat().resolvedOptions().timeZone}</div>
          &nbsp;&nbsp;
          {/* Saat */}
          <div className="max-[470px]:hidden">{time}</div>
        </div>
      </div>
    </div>
  );
});

export default TopMenu;
